import React from 'react';
import { HStack, Button, Text } from '@chakra-ui/react';
import { InfoOutlineIcon } from '@chakra-ui/icons';

const FooterLinksSection = () => (
  <HStack justify="center" spacing={4} mt={3}>
    <Button variant="link" color="gray.400" fontSize="sm" leftIcon={<img src="/png/question.png" alt="question" style={{width: '16px', height: '16px'}} />}>
      About OSSPID
    </Button>
    <Button variant="link" color="gray.400" fontSize="sm" leftIcon={<img src="/png/video_tutorial.png" alt="video tutorial" style={{width: '16px', height: '16px'}} />}>
      Video Tutorials
    </Button>
  </HStack>
);

export default FooterLinksSection; 